import React, {Component} from 'react'
import HeatMapFamily from './HeatMapFamily'
import {withRouter} from "react-router"

export class HeatMapContainer extends Component {

    render() {
        return (
            <div className='heat-map-container no-break-print'>
                {this.props.data.map((familyData, index) => <HeatMapFamily familyData={familyData}
                                                                           header={this.props.header}
                                                                           key={"heatmap-family" + index.toString()}
                />)}
            </div>
        )
    }
}

export default withRouter(HeatMapContainer)